import { generateId } from '@freelancer/datastore/testing';
import { TimeUnitApi } from 'api-typings/common/common';
import { MembershipRenewal } from './membership-renewals.model';

export interface GenerateMembershipRenewalsOptions {
  readonly userId: number;
  readonly durationType?: TimeUnitApi;
}

export function generateMembershipRenewalsObjects({
  userId,
  durationType = TimeUnitApi.MONTH,
}: GenerateMembershipRenewalsOptions): readonly MembershipRenewal[] {
  return [
    {
      id: generateId(),
      period: {
        id: generateId(),
        packageId: 7, // Intro
        timeStarted: Date.now(),
        userId,
      },
      timeOptedIn: Date.now(),
      duration: {
        cycle: 1,
        id: 1,
        type: durationType,
      },
      failureCount: 0,
    },
  ];
}
